<script setup>
// CPF/CNPJ do contato. Sem ele o painel pede o documento no lugar das
// consultas do cliente; com ele mostra o documento e deixa trocar.
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';
import messages from './i18n';
import { erroDaApi } from './api';
import { mascaraDocumento } from './format';

const props = defineProps({
  api: { type: Object, required: true },
  contato: { type: Object, required: true },
});
const emit = defineEmits(['salvo']);

const { t } = useI18n({ messages });

const editando = ref(false);
const texto = ref('');
const salvando = ref(false);
const erro = ref('');

const digitos = computed(() => texto.value.replace(/\D/g, ''));
const podeSalvar = computed(
  () =>
    !salvando.value &&
    (digitos.value.length === 11 || digitos.value.length === 14)
);
const pedindo = computed(() => editando.value || !props.contato.documento);

const digita = event => {
  texto.value = mascaraDocumento(event.target.value);
  erro.value = '';
};

const salva = async () => {
  if (!podeSalvar.value) return;
  salvando.value = true;
  erro.value = '';
  try {
    const { data } = await props.api.salvaDocumento(digitos.value);
    editando.value = false;
    texto.value = '';
    emit('salvo', data.contato);
  } catch (error) {
    erro.value = erroDaApi(error, t('NEUXS_SGP.DOCUMENTO.ERRO'));
  } finally {
    salvando.value = false;
  }
};
</script>

<template>
  <div v-if="pedindo" class="flex flex-col gap-2">
    <p v-if="!contato.documento" class="text-n-slate-11">
      {{ t('NEUXS_SGP.DOCUMENTO.EXPLICA') }}
    </p>
    <div class="flex gap-2">
      <input
        :value="texto"
        type="text"
        inputmode="numeric"
        autocomplete="off"
        :placeholder="t('NEUXS_SGP.DOCUMENTO.PLACEHOLDER')"
        :disabled="salvando"
        class="flex-1 min-w-0 px-2 py-1 mb-0 text-sm rounded-lg outline outline-1 outline-n-weak bg-n-alpha-black2 text-n-slate-12"
        @input="digita"
        @keydown.enter="salva"
      />
      <Button
        :label="t('NEUXS_SGP.DOCUMENTO.SALVAR')"
        size="sm"
        :disabled="!podeSalvar"
        :is-loading="salvando"
        @click="salva"
      />
    </div>
    <p v-if="erro" class="text-n-ruby-11">{{ erro }}</p>
  </div>

  <div v-else class="flex items-center justify-between gap-2">
    <span class="font-medium">{{ contato.documento_formatado }}</span>
    <Button
      icon="i-lucide-pencil"
      size="xs"
      variant="ghost"
      color="slate"
      :title="t('NEUXS_SGP.DOCUMENTO.TROCAR')"
      @click="editando = true"
    />
  </div>
</template>
